import React, {useEffect, useState} from 'react';
import AnimatedSuccess from "../outlet-components/AnimatedSuccess";
import HaveAny from "./HaveAny";
import {Navigate} from "react-router-dom";
import LgShrink from "../outlet-components/LgShrink";

function StepsCompleted(props) {
    const [state, setState] = useState({
        position: 'bottom',
        navigateTo: false,
    })
    useEffect(()=>{
        if (!props?.repeater){
            setTimeout(()=>{
                setState({...state, navigateTo: '../../' })
            },1500)
        }
        setState({...state,position: ''})
    },[])
    if (state.navigateTo){
        return <Navigate to={state.navigateTo}/>
    }
    return (
        <>
            <AnimatedSuccess/>
            <div className={`question-transition ${state.position}`}>
                <div className="mb-5 h3 transitionable delay-1 text-center form-label col text-info">
                    Section Complete!
                </div>

                {!!props?.repeater && (
                    <>
                        <hr className="transitionable delay-2 bg-mute mb-5"/>
                        <LgShrink>
                        <HaveAny delayStart={2} key={props.question} yesPath={props.yesPath} noPath={props.noPath} question={props.question}/>
                        </LgShrink>
                    </>

                )}
            </div>
        </>
    );
}

export default StepsCompleted;